import React from 'react'
import styled from 'styled-components'

const ArticleCard = ({articleTitle,handleViewBtn, content,handleEditBtn, thumbnail,isAdmin,handleDeleteBtn}) => {
    function createMarkup() {
        return {
           __html: content };
        }; 
    return (
        <ArticleCardWrap>
            <ArticleOption>
                <label>{articleTitle}</label>
                <div>
                    {
                        isAdmin &&
                        <span style={{fontSize: '.8rem', color: 'red', cursor: 'pointer'}} onClick={handleDeleteBtn}>Delete</span>
                    }
                   {
                       isAdmin &&
                       <ViewBtn onClick={handleEditBtn}>
                       Edit
                   </ViewBtn>
                   }
                    <ViewBtn onClick={handleViewBtn}>
                        View
                    </ViewBtn>
                </div>
            </ArticleOption>
            
            {
                thumbnail &&
                <div style={{dmaxWidth: '18rem', boxSizing: 'border-box' }}>
                    <img style={{
                        maxWidth: '19.55rem',
                        borderRadius: '5px',
                        margin: "0.2rem"
                    }} height="200px" className='thumbnail' src={thumbnail} alt="" />
                </div>
            }
            <ArticleContent dangerouslySetInnerHTML={createMarkup()}>
               
            </ArticleContent>
        </ArticleCardWrap>
    )
}

export default ArticleCard

const ArticleCardWrap = styled.div`
    width: 20rem;
    height: fit-content;
    background:  ${({theme}) => theme.background};
    border-radius: 5px;
    padding: 0.5rem 0rem;
    margin: 0.5rem 0;
    @media screen and (max-width: 768px) {
        width: 100%;
  }


`
const ArticleOption = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0.5rem 0rem;
    label {
        font-size: 1.2rem;
        color: var(--p-red);
        padding-left: 0.5rem;
    }

    .thumbnail {
        width: 2.5rem;
        height: 3em;
        object-fit: cover;
    }

`
const ViewBtn = styled.button`
  background: none;
  border: none;
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 1rem;
  text-align: right;
  color: #747178;
  cursor: pointer;
`
const ArticleContent = styled.div`
  display: flex;
  height: 3.2rem;
  overflow-y: hidden;
  text-overflow: ellipsis;
  padding: 0 0.5rem;
`